import React from 'react';
import PanelSection from '../../FormElements/PanelSection';
import DateDataType from '../../DataTable2/DataTypes/DateDataType';
import SeparatedItemsList from '../../FormElements/SeparatedItemsList';

export default class UserLoginData extends React.Component {
	constructor(props) {
		super(props);
	}

	renderRoles() {
		const { summaryData } = this.props;
		const roles =
			(summaryData && summaryData.summary && summaryData.summary.roles) || [];

		return roles.length > 0 ? (
			<div className="data-group">
				<label>{I18n.t('admin.user_profile.roles')}</label>
				<span>
					<SeparatedItemsList items={roles} property="displayAs" />
				</span>
			</div>
		) : null;
	}

	renderFieldGroup(label, value, hideIfNull) {
		if (hideIfNull && value === null) {
			return null;
		}

		let displayValue = value;

		return (
			<div className="data-group" key={label}>
				<label>{label}</label>
				<span>{displayValue || '-'}</span>
			</div>
		);
	}

	render() {
		const {
			title,
			summaryData,
			loginData,
			onShowUserLoginDataEditCardPopup
		} = this.props;

		const roles =
			(summaryData && summaryData.summary && summaryData.summary.roles) || [];
		const loginFields = (loginData && loginData.fields) || [];

		let section = null;
		if (roles.length > 0 || loginFields.length > 0) {
			const fieldElements = loginFields.map((field, index) => {
				const fieldName =
					field.displayName || `Field ${index + 1} Not Available`;
				const value = (field.value && field.value.asString) || null;
				const hideIfNull = field.hideIfNull;

				return this.renderFieldGroup(fieldName, value, hideIfNull);
			});

			section = (
				<div className="UserPersonalInfo">
					<PanelSection
						title={title}
						onClickShowPopup={onShowUserLoginDataEditCardPopup}
					>
						<div>
							{this.renderRoles()}
							{fieldElements}
							<div className="data-group">
								<label>{I18n.t('admin.user_profile.first_active')}</label>
								<span>
									<DateDataType
										value={
											(summaryData &&
												summaryData.summary &&
												summaryData.summary.firstLoginAt) ||
											null
										}
									/>
								</span>
							</div>
							<div className="data-group">
								<label>{I18n.t('admin.user_profile.last_active')}</label>
								<span>
									<DateDataType
										value={
											(summaryData &&
												summaryData.summary &&
												summaryData.summary.lastLoginAt) ||
											null
										}
									/>
								</span>
							</div>
						</div>
					</PanelSection>
				</div>
			);
		}

		return <div>{section}</div>;
	}
}
